// router/index.js (ใน frontend_admin)
import { createRouter, createWebHistory } from "vue-router";
import { useAdminAuthStore } from "@/stores/adminAuthStore";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/AdminLoginView.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/AdminDashboardView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/company-info",
    name: "company-info",
    component: () => import("../views/admin/CompanyInfoView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/company/bank-accounts",
    name: "AdminCompanyBankAccounts",
    component: () => import("../views/admin/CompanyBankAccounts.vue"),
    meta: { requiresAuth: true, role: "admin" },
  },
  {
    path: "/admin/users",
    name: "AdminManager",
    component: () => import("../views/admin/AdminManager.vue"),
    meta: {
      requiresAuth: true,
      title: "จัดการระบบ Admin",
    },
  },
  {
    path: "/admin/staff",
    name: "AdminStaffRoles",
    component: () => import("../views/admin/AdminStaffRoles.vue"),
    meta: {
      requiresAuth: true,
      title: "ข้อมูลพนักงาน (RBAC)",
    },
  },
  {
    path: "/members",
    name: "members",
    component: () => import("../views/members/AdminMemberListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/members/:id",
    name: "member-detail",
    component: () => import("../views/members/AdminMemberDetailView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/orders/detail/:type/:id",
    name: "admin-order-detail",
    component: () => import("../views/orders/AdminOrderDetailView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/income/daily/:memberId/:date/:type",
    name: "admin-income-daily-detail",
    component: () => import("../views/income/AdminIncomeDailyDetail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/income/monthly/:memberId/:bonusType",
    name: "admin-income-monthly-detail",
    component: () => import("../views/income/AdminIncomeMonthlyDetail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/master",
    name: "inventory-master",
    component: () => import("../views/inventory/InventoryMasterView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/receive-notes",
    name: "receive-notes",
    component: () => import("../views/inventory/ReceiveNoteListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/receive-note/create",
    name: "receive-note-create",
    component: () => import("../views/inventory/ReceiveNoteCreateView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/receive-note/:id",
    name: "receive-note-detail",
    component: () => import("../views/inventory/ReceiveNoteDetailView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/products",
    name: "products",
    component: () => import("../views/products/ProductMasterView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/stock-adjustment",
    name: "stock-adjustment",
    component: () => import("../views/inventory/StockAdjustmentView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory/ledger",
    name: "inventory-ledger",
    component: () => import("../views/inventory/InventoryLedgerView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/shipping",
    name: "admin-shipping",
    component: () => import("../views/admin/ShippingView.vue"),
    meta: { requiresAuth: true }, // และ check role admin
  },
  {
    path: "/admin/orders/list",
    name: "admin-orders-list",
    component: () => import("../views/admin/OrderListView.vue"),
    meta: { requiresAuth: true }, // และ check role admin
  },
  {
    path: "/admin/orders/detail/:id",
    name: "admin-order-detail",
    component: () => import("../views/admin/OrderDetailView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/allocations/list",
    name: "admin-allocations-list",
    component: () => import("../views/admin/AllocationListView.vue"),
    meta: { requiresAuth: true }, // และ check role admin
  },
  {
    path: "/admin/allocations/detail/:id",
    name: "admin-allocations-detail",
    component: () => import("../views/admin/AllocationDetailView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/wallet/approve",
    name: "AdminWalletApproval",
    component: () => import("../views/wallet/WalletApprovalView.vue"),
    meta: { requiresAuth: true, adminOnly: true, title: "อนุมัติการเติมเงิน" },
  },
  {
    path: "/admin/wallet/withdraw",
    name: "AdminWithdrawalApproval",
    component: () => import("../views/wallet/WithdrawalApprovalView.vue"),
    meta: { requiresAuth: true, adminOnly: true, title: "อนุมัติการถอนเงิน" },
  },
  {
    path: "/admin/wallet/history",
    name: "AdminWalletHistory",
    component: () => import("../views/wallet/WalletHistoryView.vue"),
    meta: {
      requiresAuth: true,
      adminOnly: true,
      title: "ประวัติธุรกรรมการเงิน",
    },
  },
  {
    path: "/admin/payout",
    name: "AdminPayoutManagement",
    component: () => import("../views/wallet/PayoutManagementView.vue"),
    meta: {
      requiresAuth: true,
      adminOnly: true,
      title: "ระบบโอนเงิน (Auto Payout)",
    },
  },
  {
    path: "/admin/payout/print",
    name: "AdminPayoutPrint",
    component: () => import("../views/wallet/PayoutPrintView.vue"),
    meta: {
      requiresAuth: true,
      adminOnly: true,
      title: "พิมพ์ใบสรุปรายการโอนเงิน",
    },
  },
  {
    path: "/admin/wallet/company-overview",
    name: "AdminCompanyWalletOverview",
    component: () => import("../views/wallet/AdminCompanyWalletView.vue"),
    meta: {
      requiresAuth: true,
      title: "บัญชี Wallet บริษัท",
    },
  },
  {
    path: "/admin/tgs-report",
    name: "AdminTgsReport",
    component: () => import("../views/wallet/AdminTgsWalletView.vue"),
    meta: { requiresAuth: true, title: "จัดการ TGS Point" },
  },
  {
    path: "/admin/promotions",
    name: "AdminPromotions",
    component: () => import("../views/promotions/AdminPromotionView.vue"),
    meta: {
      requiresAuth: true,
      title: "จัดการโปรโมชั่นและแคมเปญ",
    },
  },
  {
    // 🆕 (12 ก.ย. 2569) ระบบคูปองส่วนลด
    path: "/admin/coupons",
    name: "AdminCoupons",
    component: () => import("../views/promotions/CouponsView.vue"),
    meta: {
      requiresAuth: true,
      title: "จัดการคูปองส่วนลด",
    },
  },
  {
    // 🆕 (27 ก.ค. 2569) ระบบแต่งตั้งตัวแทน Mobile/Center
    path: "/admin/agent-appointment",
    name: "AdminAgentAppointment",
    component: () => import("../views/agents/AgentAppointmentView.vue"),
    meta: {
      requiresAuth: true,
      title: "แต่งตั้งตัวแทน Mobile/Center",
    },
  },
  {
    // 🆕 (1 ส.ค. 2569) ระบบขยายเวลาพิเศษ Fast Start/Quick Star รายบุคคล (Founder/CEO เท่านั้น)
    path: "/admin/bonus-window-override",
    name: "AdminBonusWindowOverride",
    component: () => import("../views/members/BonusWindowOverrideView.vue"),
    meta: {
      requiresAuth: true,
      title: "ขยายเวลาพิเศษ Fast Start/Quick Star",
    },
  },
  {
    // 🆕 (9 ส.ค. 2569) จัดการแบนเนอร์แม่แบบสำหรับฟีเจอร์ "สร้างแบนเนอร์ QR ของฉัน" (สมาชิก)
    path: "/admin/banner-templates",
    name: "AdminBannerTemplates",
    component: () => import("../views/members/BannerTemplatesView.vue"),
    meta: {
      requiresAuth: true,
      title: "จัดการแบนเนอร์ QR สปอนเซอร์",
    },
  },
  {
    path: "/admin/leadership-report",
    name: "AdminLeadershipReport",
    component: () => import("../views/admin/LeadershipReport.vue"),
    meta: {
      requiresAuth: true,
      title: "รายงาน Leadership Bonus (ข้อ 8)",
    },
  },
  {
    path: "/admin/team-builder-report",
    name: "AdminTeamBuilderReport",
    component: () => import("../views/admin/TeamBuilderReport.vue"),
    meta: {
      requiresAuth: true,
      title: "รายงาน Team Builder Bonus (ข้อ 9)",
    },
  },
  {
    path: "/admin/all-sale-report",
    name: "AdminAllSaleReport",
    component: () => import("../views/admin/AllSaleReport.vue"),
    meta: {
      requiresAuth: true,
      title: "รายงาน All Sales Bonus (ข้อ 10)",
    },
  },
  {
    path: "/admin/loyalty-report",
    name: "AdminLoyaltyReport",
    component: () => import("../views/admin/LoyaltyReport.vue"),
    meta: { requiresAuth: true, title: "รายงาน Loyalty Bonus & Auto-Ship" },
  },
  {
    path: "/admin/saving-report",
    name: "AdminSavingReport",
    component: () => import("../views/wallet/AdminSavingReportView.vue"),
    meta: { requiresAuth: true, title: "ภาพรวม Saving Bonus" },
  },
  {
    path: "/admin/saving-withdrawals",
    name: "AdminSavingWithdrawals",
    component: () => import("../views/wallet/AdminSavingWithdrawalView.vue"),
    meta: { requiresAuth: true, title: "จัดการคำขอถอน Saving Bonus" },
  },
  {
    path: "/admin/top-sponsor-report",
    name: "AdminTopSponsorReport",
    component: () => import("../views/admin/TopSponsorReport.vue"),
    meta: {
      requiresAuth: true,
      title: "รายงาน Top Sponsor ประจำเดือน",
    },
  },
  {
    path: "/admin/workplan/steps",
    name: "admin-workplan-steps",
    component: () => import("../views/workplan/WorkPlanSteps.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/workplan/meeting",
    name: "admin-meeting-command-center", // เปลี่ยนชื่อให้สื่อความหมาย
    component: () => import("../views/workplan/MeetingCommandCenter.vue"),
    meta: {
      requiresAuth: true,
      title: "Meeting Command Center",
    },
  },
  {
    path: "/admin/startup",
    name: "admin-startup",
    component: () => import("../views/workplan/StartupCommandCenter.vue"),
    meta: { requiresAuth: true, title: "5 Start Up Management" },
  },
  {
    path: "/admin/workplan/growth-system",
    name: "admin-growth-system",
    component: () => import("../views/workplan/GrowthLibraryView.vue"),
    meta: { requiresAuth: true, title: "Human Growth OS Manager" },
  },
  {
    path: "/admin/giver-ai/manager",
    name: "admin-giver-ai-manager",
    component: () => import("../views/giverai/GiverAIManagerView.vue"),
    meta: { requiresAuth: true, title: "Giver AI Manager (FAQ)" },
  },
  {
    path: "/admin/communication/announcements",
    name: "admin-manage-announcements",
    component: () => import("../views/Communication/ManageAnnouncements.vue"),
    meta: {
      requiresAuth: true,
      title: "จัดการข่าวสาร (Announcements)",
    },
  },
  {
    path: "/admin/system-tools",
    name: "SystemTools",
    component: () => import("../views/admin/SystemToolsView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/comp-plan-settings",
    name: "comp-plan-settings",
    component: () => import("../views/CEO/CompPlanSettings.vue"), // ปรับเส้นทาง (views/CEO หรือ views/admin) ให้ตรงกับที่เซฟไฟล์หน้าหลักไว้นะครับ
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/financial/dashboard",
    name: "admin-financial-dashboard",
    component: () => import("../views/CEO/FinancialDashboard.vue"),
    meta: {
      requiresAuth: true,
      title: "รายงานวิเคราะห์งบการเงิน (Financial Dashboard)",
    },
  },
  // 🆕 (12 ต.ค. 2569) ตรวจ/อนุมัติเรื่องราวสมาชิก (หน้าเปิดใจผู้มุ่งหวัง เฟส 2)
  {
    path: "/admin/member-stories",
    name: "member-stories",
    component: () => import("../views/prospect/MemberStoriesView.vue"),
    meta: { requiresAuth: true, title: "อนุมัติเรื่องราวสมาชิก" },
  },
  // 🆕 (14 ต.ค. 2569) รายงาน CEO + ตั้งค่าระบบหน้าเปิดใจผู้มุ่งหวัง (เฟส 5)
  {
    path: "/admin/prospect-page-analytics",
    name: "prospect-page-analytics",
    component: () => import("../views/CEO/ProspectPageAnalytics.vue"),
    meta: { requiresAuth: true, title: "รายงานหน้าเปิดใจผู้มุ่งหวัง" },
  },
  {
    path: "/admin/prospect-page-settings",
    name: "prospect-page-settings",
    component: () => import("../views/prospect/ProspectPageSettings.vue"),
    meta: { requiresAuth: true, title: "ตั้งค่าหน้าเปิดใจผู้มุ่งหวัง" },
  },
  {
    path: "/admin/funnel-analytics",
    name: "funnel-analytics",
    component: () => import("../views/CEO/FunnelAnalytics.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/startup-analytics",
    name: "startup-analytics",
    component: () => import("../views/CEO/StartupAnalytics.vue"),
    meta: { requiresAuth: true },
  },

  // (ในอนาคต หน้า Admin อื่นๆ ก็จะถูกเพิ่มที่นี่)
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

//  "ยาม" (Navigation Guard) - ถูกต้องแล้ว
router.beforeEach((to, from, next) => {
  // (เราต้อง Import Store "ข้างใน" นี้ เพื่อหลีกเลี่ยงปัญหา Circular Dependency)
  const authStore = useAdminAuthStore();
  const requiresAuth = to.meta.requiresAuth;

  if (requiresAuth && !authStore.isAuthenticated) {
    next("/login");
  } else if (!requiresAuth && authStore.isAuthenticated) {
    next("/");
  } else {
    next();
  }
});

// --- โค้ดสำหรับเปลี่ยนชื่อ Tab อัตโนมัติ ---
router.beforeEach((to, from, next) => {
  const baseTitle = "TGS_Admin"; // ชื่อหลักของระบบ

  // ถ้าหน้านั้นมีตั้งค่า meta.title ไว้ ให้เอามาต่อท้ายชื่อหลัก
  if (to.meta.title) {
    document.title = `${baseTitle} | ${to.meta.title}`;
  } else {
    // ถ้าหน้าไหนไม่ได้ตั้งไว้ ก็ให้โชว์แค่ TGS_Admin เฉยๆ
    document.title = baseTitle;
  }

  next();
});

export default router;
